


export type BillAssignmentRuleOptionType = 'Supplier' | 'Purchaser' | 'PositionCostCentre' | 'Account' | 'Customer' | 'Project' | 'PrivateWorkspace' | 'GroupWorkspace' | 'CostCentreWorkspace';

export const BillAssignmentRuleOptionType = {
    Supplier: 'Supplier' as BillAssignmentRuleOptionType,
    Purchaser: 'Purchaser' as BillAssignmentRuleOptionType,
    PositionCostCentre: 'PositionCostCentre' as BillAssignmentRuleOptionType,
    Account: 'Account' as BillAssignmentRuleOptionType,
    Customer: 'Customer' as BillAssignmentRuleOptionType,
    Project: 'Project' as BillAssignmentRuleOptionType,
    PrivateWorkspace: 'PrivateWorkspace' as BillAssignmentRuleOptionType,
    GroupWorkspace: 'GroupWorkspace' as BillAssignmentRuleOptionType,
    CostCentreWorkspace: 'CostCentreWorkspace' as BillAssignmentRuleOptionType
};

